import styled from 'styled-components';
import { getPaletteColor, themeGet } from '@magalu/stereo-ui-styles';
export const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  color: ${props => getPaletteColor('primary.text')(props)};
`;
export const LogoPrefix = styled.strong`
  color: ${props => getPaletteColor('primary.dark')(props)};
  margin-right: 2px;
`;
export const LogoText = styled.span`
  display: block;
  margin-bottom: 5px;
  font-size: ${props => themeGet('fontSizes.4')(props)}px;
  font-weight: ${props => themeGet('fontWeights.bold')(props)};
  line-height: ${props => themeGet('lineHeights.fontSize')(props)};
`;
export const LogoLegend = styled.div`
  font-size: ${props => themeGet('fontSizes.0')(props)}px;
  margin-bottom: 5px;
`;